export enum DialogTypeEnum {
  ACTIVE_MISSIONS = 'ACTIVE_MISSIONS',
  MISSIONS = 'MISSIONS',
  MISSION_HISTORY = 'MISSION_HISTORY',
}
